import { render, staticRenderFns } from "./customerProfile.vue?vue&type=template&id=72ebed1d&scoped=true"
import script from "./customerProfile.vue?vue&type=script&lang=js"
export * from "./customerProfile.vue?vue&type=script&lang=js"
import style0 from "./customerProfile.vue?vue&type=style&index=0&id=72ebed1d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ebed1d",
  null
  
)

export default component.exports